import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class BreadcrumbBuilder {

  public eventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  public add(item: { label: string, url: string }) {
    this.eventEmitter.emit({ type: 'add', item: item });
  }

  public clear() {
    this.eventEmitter.emit({ type: 'clear' });
  }
}
